import api from "@/helpers/api";

export type UrlAccess = "public" | "members";

export interface AuditableUrl {
  id: number;
  url: string;
  label: string;
  access: UrlAccess;
}

export type AuditableUrlGroups = Record<string, AuditableUrl[]>;

export const getAuditableUrls = (force = false) =>
  api.get({
    path: "/auditable-urls",
    ...(force ? { params: { force: true } } : {}),
  }) as Promise<AuditableUrlGroups>;
